import { createSlice } from '@reduxjs/toolkit';
import { ISupplier } from '../../../../dto';
import { setSuppliers } from '../actions';
import { MN_SUPPLIERS, TYPE_LIST } from '../../../../common';

export interface SuppliersState {
  data: ISupplier[];
  loading: boolean;
  error: string | null;
}

const initialState: SuppliersState = {
  data: [],
  loading: false,
  error: null,
};

export const suppliersSlice = createSlice({
  name: `${MN_SUPPLIERS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSuppliers, (state, { payload }) => {
      state.data = payload;
    });
  },
});
